import { UserAgentApplication } from 'msal';
import { get, getSingleSignOn } from "@/services/client.service";

// import {
//   APP_URL,
//   AUTH_APP_CLIENT_ID,
//   AUTH_DOMAIN,
// } from '@/config';


const APP_URL= get('APP_URL');
const AUTH_APP_CLIENT_ID = getSingleSignOn('clientID');
const AUTH_DOMAIN = `https://login.microsoftonline.com/${getSingleSignOn('tenantID')}`;
// const AUTH_DOMAIN = 'https://login.microsoftonline.com/95fd57a3-d5a7-4768-ba46-ffb454b6778a';
// http://localhost:8080/auth/capture672/wfs
const msalConfig = {
  auth: {
    clientId: AUTH_APP_CLIENT_ID,
    authority: AUTH_DOMAIN,
    redirectUri: `${APP_URL}/auth/capture672/wfs`,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
};

// alert(`${APP_URL}/auth/capture672/wfs`);

const loginRequest = {
  scopes: ['openid', 'profile', 'User.Read'],
};

const adAuth = new UserAgentApplication(msalConfig);
// let adAuth = null;
// const initiate = () => {
//   adAuth = new UserAgentApplication(msalConfig);
// }
const initiate = () => {};

const handleTokenResponse = (response) => {
  // alert('response');
  // console.log('handleTokenResponse', response);
  localStorage.setItem('azure_id_token', response.idToken.rawIdToken);
  const expiresAt = new Date(response.expiresOn).getTime();
  localStorage.setItem('azure_expires_at', JSON.stringify(expiresAt));

  const profile = {
    id: response.uniqueId,
    name: response.account.name,
    email: response.account.userName,
  };
  localStorage.setItem('azure_profile', JSON.stringify(profile));
};

const handleAuthentication = () => new Promise((resolve, reject) => {
  // alert('hello');
  // alert('handleAuthentication');
  try {
    adAuth.acquireTokenSilent(loginRequest)
      .then((tokenResponse) => {
        handleTokenResponse(tokenResponse);
        resolve(tokenResponse);
      }).catch((error) => {
        reject(error);
      });
  } catch (error) {
    // alert(error);
    reject(error);
  }
});

adAuth.handleRedirectCallback((err, response) => {
  // alert('2');
  if (!err) {
    handleTokenResponse(response);
  }
});



const login = () => {
  // alert(JSON.stringify(loginRequest));
  adAuth.loginRedirect(loginRequest);
};

const logout = () => {
  localStorage.removeItem('azure_id_token');
  localStorage.removeItem('azure_expires_at');
  localStorage.removeItem('azure_profile');
  adAuth.logout();
};

const getExpiresAt = () => JSON.parse(localStorage.getItem('azure_expires_at'));

const getProfile = () => {
  const profile = JSON.parse(localStorage.getItem('azure_profile')) || {};
  return profile;
};

const getToken = () => localStorage.getItem('azure_id_token');

//();

export {
  initiate,
  handleAuthentication,
  login,
  logout,
  getProfile,
  getExpiresAt,
  getToken,
};
